import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';
import Button from './Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  loading?: boolean;
};

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'primary',
  loading = false
}: Props) => {
  return (
    <Modal isOpen={open} toggle={onClose} size="sm">
      <ModalHeader toggle={onClose}>
        <span>{title}</span>
      </ModalHeader>
      <ModalBody>
        <p className="mb-0">{message}</p>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-end gap-2 w-100">
          <Button
            outline
            color="secondary"
            onClick={onClose}
            type="button"
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button
            color={confirmColor}
            onClick={async () => {
              try {
                await onConfirm();
                onClose();
              } catch {
                // Error is handled by the mutation's onError
              }
            }}
            type="button"
            loading={loading}
          >
            {confirmText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDialog;
